import * as C from "../Vars/charts";
import Helper from "./Helper.js";
import * as Excel from "exceljs/dist/exceljs.min.js";
import {
  saveAs
} from 'file-saver'


class ChartXDownloader {
  constructor() {
    this.addDownload();
  }

  /**
   * XDownloader
   */

  addDownload(){
    const downloadButton = document.querySelector('.ns-actions__xls');
    if(!!downloadButton){
      downloadButton.addEventListener('click', () => { this.generateExcel() });
    }
  }

  generateExcel(){
    const table = document.querySelector('.ns-chart-comparison__chart-area #table-container table tbody');
    this.createWorkbook(table);
  }

  createWorkbook(table) {
    const name = document.querySelector('#chartName').innerText;
    const workbook = new Excel.Workbook();
    this.worksheet = 0;
    this.worksheet = workbook.addWorksheet(name);
    this.parseTable(table);
    this.saveFile(name, workbook);
  }

  /**
   * savefile doesnt need explanation as well
   * @param {*} fileName
   * @param {*} workbook
   */
  async saveFile(fileName, workbook) {
    const xls64 = await workbook.xlsx.writeBuffer({
      base64: true
    })
    saveAs(
      new Blob([xls64], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }),
      fileName + '.xlsx'
    )
  }

  getTitle(){
    let h1 = document.querySelector('.ns-title-h1');
    const company = 'Mobiliar';
    return company + ' ' + h1.innerText;
  }

  parseTable(table) {
    const rows = Array.prototype.slice.call(table.querySelectorAll('tr'));
    let row;
    let content = [];

    let counterR = 0;
    let counterC = 0;
    let first = true;
    
    let title = this.getTitle();
    

    rows.forEach(r => {
      counterR++; //counters to keep track where you are
      counterC = 0;
      content = [];
      let tds;
      if(first){
        tds = Array.prototype.slice.call(r.querySelectorAll('th'));
        this.worksheet.columns = [
          { header: '', key: '', width: 60 },
        ];
        row = this.worksheet.lastRow;
        row.height = 0.5;
        if(title){
          this.worksheet.addRow([title]);
          row = this.worksheet.lastRow;
          
          row.getCell('A').font = {
            size: 16,
            bold: true
          };
          
          this.worksheet.addRow([]);
        } 
      } else{
        tds = Array.prototype.slice.call(r.querySelectorAll('td'));
      }
      
      tds.forEach(t => { //second iteration for actual content
        counterC++;


        let c = t.innerText;

        if (counterC == 1) { //apparently this is still considered not NaN
          c = c;
        } else {
          c = parseFloat(this.correct(c));
        }

        content.push(c);
      });

      this.worksheet.addRow(content);

      row = this.worksheet.lastRow;

      if(first){
        first = false;
        for (let i = 1; i < (tds.length + 1); i++) {
          row.getCell(i).font = {
            bold: true
          };
          row.getCell(i).border = { 
            bottom: {
              style: 'thin',
              color: {
                argb: 'FFB3AEA6'
              }
            }
          };
          row.getCell(i).fill = { 
            type: 'pattern',
            pattern: 'solid',
            fgColor: {
              rgb: 'FFFFFFFF'
            }
          }
        }
      } else{
        row.getCell(1).font = {
          bold: true
        }
        for (let i = 1; i < (tds.length + 1); i++) {
          row.getCell(i).border = { bottom: {
              style: 'thin',
              color: {
                argb: 'FFB3AEA6'
              }
            }
          };
          row.getCell(i).fill = { 
            type: 'pattern',
            pattern: 'solid',
            fgColor: {
              rgb: 'FFFFFFFF'
            }
          }

        }
      }
    });
  }

  correct(text) {
    console.log(text);
    return text.replace(/'/g, '').replace(/\s/g, '').replace(/\s/g, '').replace(/–/g, '-').replace(/,/g, '.');
  }

  correctNote(text) {
    return text.replace(/'/g, '').replace(/’/g, '').replace(/–/g, '-');
  }

} export default ChartXDownloader;
